module.exports = __webpack_public_path__ + "static/media/no-content.e5c823c1.svg";